import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import { useTrialAuth } from "../../Context/TrialAuthContext";
import DeleteIcon from "./../../Images/black-x.png";

const CardTrial = ({ data, setHeadingFocused }) => {
  const context = useTrialAuth();
  const [cardFocused, setCardFocused] = useState(false);

  // Guard against undefined context
  if (!context) {
    return null;
  }

  const { editLocalData, editLocalNumberData, deleteLocalData } = context;

  function handleEdit(e, id) {
    const regex = /^(\d+(\.\d{0,5})?|\.?\d{1,2})$/;
    if (
      e.target.name.includes("price") ||
      e.target.name.includes("variableCost") ||
      e.target.name.includes("workHours") ||
      e.target.name.includes("volumeYear")
    ) {
      if (e.target.value.match(regex)) {
        editLocalNumberData(e, id);
      } else if (e.target.value === "") {
        editLocalNumberData(e, id);
        handleZero(e);
      } else {
        e.target.value = e.target.value.replace(/[^/\d\d{1,2}]/g, "");
      }
    } else {
      editLocalData(e, id);
    }
  }

  // If input is 0 select/highlight 0
  function handleZero(e) {
    if (e.target.value === "0") {
      e.target.select();
    }
  }

  function handleDelete(id) {
    deleteLocalData(id);
  }

  // Calculations
  // täckningsbidrag = Försäljn.pris/per styck - Rörlig kostn/per styck
  function grossMargin(price, variableCost) {
    let a = parseFloat(price);
    let b = parseFloat(variableCost);
    const result = a - b;
    if (isNaN(result) || !isFinite(result)) {
      return "";
    } else {
      return result.toFixed(2);
    }
  }

  // täckningsgrad = (täckningsbidrag * 100) / Försäljn.pris/per styck
  function coverage(price, variableCost) {
    let a = parseFloat(price);
    let b = parseFloat(variableCost);

    const result = ((a - b) * 100) / a;
    if (isNaN(result) || !isFinite(result)) {
      return "";
    } else {
      return result.toFixed(1);
    }
  }

  // täckningsbidrag per timme (täckningsbidrag / arbetstid per timme)
  function grossMarginHour(price, variableCost, workHour) {
    let a = parseFloat(price);
    let b = parseFloat(variableCost);
    let c = parseFloat(workHour);
    let result = (a - b) / c;
    if (isNaN(result) || !isFinite(result)) {
      return "";
    } else {
      if (result % 1 === 0) {
        return parseInt(result, 10);
      } else {
        return parseFloat(result, 10).toFixed(1);
      }
    }
  }

  // årsförsäljning
  function annualSales(price, volumeYear) {
    let a = parseFloat(price);
    let b = parseFloat(volumeYear);
    const result = a * b;
    if (isNaN(result) || !isFinite(result)) {
      return "";
    } else {
      return result;
    }
  }

  // årstäckningsbidrag
  function yearGrossMargin(price, variableCost, volumeYear) {
    let a = parseFloat(price);
    let b = parseFloat(variableCost);
    let c = parseFloat(volumeYear);
    const grossMargin = a - b;
    const result = grossMargin * c;
    if (isNaN(result) || !isFinite(result)) {
      return "";
    } else {
      return result;
    }
  }

  return (
    <div>
      <Row
        className={`
          g-0 mt-2 m-auto rounded-3 
          ${cardFocused ? "cards-focused" : "cards"} 
        `}
        onFocus={() => setCardFocused(true)}
        onBlur={() => setCardFocused(false)}
      >
        <Col xs={5} className="p-2 ps-3" style={{ padding: "0px" }}>
          <input
            type="text"
            className={` 
              form-control text-center 
              ${cardFocused ? "input-element-focused" : "input-element"}
            `}
            name="category"
            defaultValue={data.object.category}
            maxLength="30"
            autoComplete="off"
            onChange={(e) => handleEdit(e, data.id)}
            onFocus={(e) =>
              setHeadingFocused && setHeadingFocused(e.target.name)
            }
            onBlur={() => setHeadingFocused && setHeadingFocused("")}
          />
        </Col>
        <Col xs={5} className="p-2" style={{ padding: "0px" }}>
          <input
            type="text"
            className={` 
              form-control text-center 
              ${cardFocused ? "input-element-focused" : "input-element"}
            `}
            name="product"
            defaultValue={data.object.product}
            maxLength="30"
            autoComplete="off"
            onChange={(e) => handleEdit(e, data.id)}
            onFocus={(e) =>
              setHeadingFocused && setHeadingFocused(e.target.name)
            }
            onBlur={() => setHeadingFocused && setHeadingFocused("")}
          />
        </Col>
        <Col xs={3} className="offset-1 p-2" style={{ padding: "0px" }}>
          <input
            type="text"
            className={` 
              form-control text-center 
              ${cardFocused ? "input-element-focused" : "input-element"}
            `}
            name="price"
            defaultValue={data.object.price === "0" ? "" : data.object.price}
            maxLength="7"
            autoComplete="off"
            onChange={(e) => handleEdit(e, data.id)}
            onFocus={(e) =>
              setHeadingFocused && setHeadingFocused(e.target.name)
            }
            onBlur={() => setHeadingFocused && setHeadingFocused("")}
            onClick={(e) => handleZero(e)}
          />
        </Col>
        <Col xs={3} className="p-2" style={{ padding: "0px" }}>
          <input
            type="text"
            className={` 
              form-control text-center 
              ${cardFocused ? "input-element-focused" : "input-element"}
            `}
            name="variableCost"
            defaultValue={
              data.object.variableCost === "0" ? "" : data.object.variableCost
            }
            maxLength="7"
            autoComplete="off"
            onChange={(e) => handleEdit(e, data.id)}
            onFocus={(e) =>
              setHeadingFocused && setHeadingFocused(e.target.name)
            }
            onBlur={() => setHeadingFocused && setHeadingFocused("")}
            onClick={(e) => handleZero(e)}
          />
        </Col>
        <Col xs={3} className="p-2" style={{ padding: "0px" }}>
          <output
            className={` 
              form-control text-center 
              ${cardFocused ? "output-element-focused" : "output-element"}
            `}
            name="grossMargin"
          >
            {grossMargin(data.object.price, data.object.variableCost)}
          </output>
        </Col>
        <Col xs={3} className="p-2" style={{ padding: "0px" }}>
          <output
            className={` 
              form-control text-center 
              ${cardFocused ? "output-element-focused" : "output-element"}
            `}
            name="coverage"
          >
            {coverage(data.object.price, data.object.variableCost)}
          </output>
        </Col>
        <Col xs={3} className="p-2" style={{ padding: "0px" }}>
          <input
            type="text"
            className={` 
              form-control text-center 
              ${cardFocused ? "input-element-focused" : "input-element"}
            `}
            name="workHours"
            defaultValue={
              data.object.workHours === "0" ? "" : data.object.workHours
            }
            maxLength="7"
            autoComplete="off"
            onChange={(e) => handleEdit(e, data.id)}
            onFocus={(e) =>
              setHeadingFocused && setHeadingFocused(e.target.name)
            }
            onBlur={() => setHeadingFocused && setHeadingFocused("")}
            onClick={(e) => handleZero(e)}
          />
        </Col>
        <Col xs={3} className="p-2" style={{ padding: "0px" }}>
          <output
            className={` 
              form-control text-center 
              ${cardFocused ? "output-element-focused" : "output-element"}
            `}
            name="grossMarginHour"
          >
            {grossMarginHour(
              data.object.price,
              data.object.variableCost,
              data.object.workHours
            )}
          </output>
        </Col>
        <Col xs={3} className="p-2" style={{ padding: "0px" }}>
          <input
            type="text"
            className={` 
              form-control text-center 
              ${cardFocused ? "input-element-focused" : "input-element"}
            `}
            name="volumeYear"
            defaultValue={
              data.object.volumeYear === "0" ? "" : data.object.volumeYear
            }
            maxLength="7"
            autoComplete="off"
            onChange={(e) => handleEdit(e, data.id)}
            onFocus={(e) =>
              setHeadingFocused && setHeadingFocused(e.target.name)
            }
            onBlur={() => setHeadingFocused && setHeadingFocused("")}
            onClick={(e) => handleZero(e)}
          />
        </Col>
        <Col xs={3} className="p-2" style={{ padding: "0px" }}>
          <output
            className={` 
              form-control text-center 
              ${cardFocused ? "output-element-focused" : "output-element"}
            `}
            name="annualSales"
          >
            {annualSales(data.object.price, data.object.volumeYear)}
          </output>
        </Col>
        <Col xs={3} className="p-2" style={{ padding: "0px" }}>
          <output
            className={` 
              form-control text-center 
              ${cardFocused ? "output-element-focused" : "output-element"}
            `}
            name="annualContribution"
          >
            {yearGrossMargin(
              data.object.price,
              data.object.variableCost,
              data.object.volumeYear
            )}
          </output>
        </Col>

        <Col
          xs={1}
          className={`
            offset-1 pe-2 d-flex align-items-center
            ${
              cardFocused
                ? "cards-delete-button-focused"
                : "cards-delete-button"
            }
          `}
          onClick={() => handleDelete(data.id)}
        >
          <img
            src={DeleteIcon}
            alt="Delete icon"
            className="img-fluid max-width:100% height:auto mx-auto d-block w-75 x-button"
          />
        </Col>
      </Row>
    </div>
  );
};

export default CardTrial;
